import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';

import App from './App';
import apolloClient from './apollo';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
